import jobs from "@/assets/demo-jobs.webp.asset.json";
import progress from "@/assets/demo-progress.webp.asset.json";
import mission from "@/assets/demo-mission-control.webp.asset.json";
import competitors from "@/assets/demo-competitors.webp.asset.json";
import journey from "@/assets/demo-journey.webp.asset.json";

const SHOTS = {
  jobs: { src: jobs.url, alt: "Monroya Jobs page for an example account: this week's ranked moves, each with a draft ready" },
  progress: { src: progress.url, alt: "Monroya Progress page for an example account: readiness trend and before-and-after AI answers" },
  mission: { src: mission.url, alt: "Monroya Mission Control for an example account: what AI assistants say at each buyer stage" },
  competitors: { src: competitors.url, alt: "Monroya Competitors page for an example account: who AI names instead, per assistant" },
  journey: { src: journey.url, alt: "Monroya buyer-journey view for an example account: visibility by stage and assistant" },
} as const;

/** Clean demo capture with a separate caption (no added frames). */
export function DemoShot({ shot, caption }: { shot: keyof typeof SHOTS; caption: string }) {
  const s = SHOTS[shot];
  return (
    <figure className="my-2">
      <img src={s.src} alt={s.alt} loading="lazy" decoding="async" className="w-full rounded-md border border-border" />
      <figcaption className="mt-2 text-[13px] text-muted-foreground">{caption}</figcaption>
    </figure>
  );
}
